import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';

import QRCode from 'qrcode.react';

import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button
} from '@material-ui/core';

import { PageContext } from '../../PageContext';

import { useTranslation } from "react-i18next";

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {}
}));

export const PublishConfigDialog = ({
    open,
    onConfirm,
    onClose,
    ...props
}) => {
    const classes = useStyles();

    const { t } = useTranslation();

    const {
        state
    } = useContext(PageContext);

    return (
        <Dialog
            className={clsx(classes.root, props.className)}
            open={open}
            onClose={onClose}>
            <DialogTitle>
                {t("DialogPublish")}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {t("LabelConfirmPublishConfig")}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    autoFocus
                    onClick={onConfirm}
                    color="primary">
                    {t("ButtonOk")}
                </Button>
                <Button
                    autoFocus
                    onClick={onClose}
                    color="primary">
                    {t("ButtonCancel")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}